import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { EmvioRow } from '@nexio/emvio-util-ui';
import { doesPropExistAndHasItChanged } from '@nexio/emvio-util-app';

import { getIsMerchantsLoaded } from '../Merchants/merchantsEntity';
import { getKpiTransactionSummary, getKpiMonthlyChargebackCount } from './Widgets/kpiActions';
import {
    getIsMonthlyChargebackCountLoading,
    getMonthlyChargebackCountErrorMessage,
    getMonthlyChargebackCountMtdCount,
    getMonthlyChargebackCountPreviousMonthCount,
    getTransactionSummaryErrorMessage,
    getTransactionSummary,
    getTransactionSummaryIsLoading
} from './Widgets/kpiEntity';
import { toastIfError } from '../../utils/toast';
import TransactionChart from './TransactionChart/TransactionChart';
import mixpanel from 'mixpanel-browser';
import config from '../../config/config';
import { getSelectedMerchants } from '../MerchantSelector/merchantSelectorViewState';
import { getWidgetSettingsEntity } from '../WidgetSettings/widgetSettingsEntity';
import { filterMerchantsByCurrencyAsString } from '../WidgetSettings/widgetSettingsActions';
import TransactionsWidget from './Widgets/TransactionsWidget/TransactionsWidget';
import ApproveDeclineWidget from './Widgets/ApproveDeclineWidget/ApproveDeclineWidget';
import SalesWidget from './Widgets/SalesWidget/SalesWidget';
import ChargebacksWidget from './Widgets/ChargebacksWidget/ChargebacksWidget';
import { getSelf } from '../Self/selfEntity';
import './Dashboard.scss';
import _ from 'lodash';

export class Dashboard extends Component {
    static propTypes = {
        monthlyChargebackCountErrorMessage: PropTypes.string,
        transactionSummaryErrorMessage: PropTypes.string,
        isMerchantsLoaded: PropTypes.bool,
        isMonthlyChargebackCountLoading: PropTypes.bool,
        isTransactionSummaryLoading: PropTypes.bool,
        onGetMonthlyChargebackCount: PropTypes.func,
        onGetTransactionSummary: PropTypes.func,
        selectedMerchants: PropTypes.array,
        selectedMerchantsString: PropTypes.string,
        settings: PropTypes.shape({
            currencyId: PropTypes.string,
            currencyCode: PropTypes.string
        }),
        mtdChargebackCount: PropTypes.number,
        previousMonthChargebackCount: PropTypes.number,
        transactionSummary: PropTypes.shape({
            yesterdaySaleAmount: PropTypes.number,
            yesterdaySaleCount: PropTypes.number,
            yesterdayDeclineCount: PropTypes.number,
            lastThirtySaleAmount: PropTypes.number,
            lastThirtySaleCount: PropTypes.number,
            lastThirtyRefundAmount: PropTypes.number,
            lastThirtyDeclineCount: PropTypes.number,
            previousThirtySaleAmount: PropTypes.number,
            previousThirtySaleCount: PropTypes.number,
            previousThirtyRefundAmount: PropTypes.number,
            lastThirtyAverageSaleAmount: PropTypes.number,
            yesterdayAverageSaleAmount: PropTypes.number,
            yesterdayVsLastThirtyAverageSaleAmount: PropTypes.number,
            lastThirtyVsPreviousThirtySaleCount: PropTypes.number,
            lastThirtyVsPreviousThirtySaleAmount: PropTypes.number,
            lastThirtyVsPreviousThirtyRefundAmount: PropTypes.number,
            lastThirtyApprovalPercentage: PropTypes.number,
            yesterdayApprovalPercentage: PropTypes.number,
            yesterdayVsLastThirtyApprovalPercentage: PropTypes.number,
            topDeclineReasons: PropTypes.array,
            monthToDaySaleCount: PropTypes.number,
            previousMonthToDaySaleCount: PropTypes.number
        }),
        user: PropTypes.any
    };

    componentDidMount() {
        if (this.props.selectedMerchants) {
            const merchantsForData = filterMerchantsByCurrencyAsString(this.props.selectedMerchants, this.props.settings);

            this.props.onGetMonthlyChargebackCount(merchantsForData);
            this.props.onGetTransactionSummary(merchantsForData);
        }

        mixpanel.init(_.get(config, 'mixpanel.token', ''));

        if (this.props.user) {
            mixpanel.identify(this.props.user.userName);
        }

        mixpanel.track('Dashboard page mounted');
    }

    componentDidUpdate(prevProps) {
        toastIfError(prevProps, this.props, 'transactionSummaryErrorMessage');
        toastIfError(prevProps, this.props, 'monthlyChargebackCountErrorMessage');

        if (doesPropExistAndHasItChanged(prevProps, this.props, 'selectedMerchants') || doesPropExistAndHasItChanged(prevProps, this.props, 'settings')) {
            const merchantsForData = filterMerchantsByCurrencyAsString(this.props.selectedMerchants, this.props.settings);

            if (merchantsForData) {
                this.props.onGetMonthlyChargebackCount(merchantsForData);
                this.props.onGetTransactionSummary(merchantsForData);
            }
        }
    }

    render() {
        const { transactionSummary, previousMonthChargebackCount, mtdChargebackCount } = this.props;

        return (
            <div className="emvio-dashboard">
                <EmvioRow>
                    <div className="title">
                        Total Sales
                    </div>
                </EmvioRow>
                <div className="top-card" >
                    <TransactionChart />
                </div>
                <div className="widget-card">
                    <TransactionsWidget
                        currencyCode={this.props.settings.currencyCode}
                        lastThirtySaleCount={transactionSummary.lastThirtySaleCount}
                        lastThirtyVsPreviousThirtySaleCount={transactionSummary.lastThirtyVsPreviousThirtySaleCount}
                        yesterdayAverageSaleAmount={transactionSummary.yesterdayAverageSaleAmount}
                        yesterdayVsLastThirtyAverageSaleAmount={transactionSummary.yesterdayVsLastThirtyAverageSaleAmount}
                    />
                    <ApproveDeclineWidget
                        hasTransactionsFromYesterday={!!transactionSummary.yesterdaySaleCount || !!transactionSummary.yesterdayDeclineCount}
                        yesterdayApprovalPercentage={transactionSummary.yesterdayApprovalPercentage}
                        yesterdayVsLastThirtyApprovalPercentage={transactionSummary.yesterdayVsLastThirtyApprovalPercentage}
                        topDeclineReasons={transactionSummary.topDeclineReasons}
                    />
                    <SalesWidget
                        currencyCode={this.props.settings.currencyCode}
                        lastThirtySaleAmount={transactionSummary.lastThirtySaleAmount}
                        lastThirtyVsPreviousThirtySaleAmount={transactionSummary.lastThirtyVsPreviousThirtySaleAmount}
                        lastThirtyRefundAmount={transactionSummary.lastThirtyRefundAmount}
                        lastThirtyVsPreviousThirtyRefundAmount={transactionSummary.lastThirtyVsPreviousThirtyRefundAmount}
                    />
                    <ChargebacksWidget
                        mtdChargebackCount={mtdChargebackCount}
                        mtdTransactionCount={transactionSummary.monthToDaySaleCount}
                        previousMonthChargebackCount={previousMonthChargebackCount}
                        previousMonthTransactionCount={transactionSummary.previousMonthToDaySaleCount}
                    />
                </div>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        isMerchantsLoaded: getIsMerchantsLoaded(state),
        isMonthlyChargebackCountLoading: getIsMonthlyChargebackCountLoading(state),
        isTransactionSummaryLoading: getTransactionSummaryIsLoading(state),
        selectedMerchants: getSelectedMerchants(state),
        settings: getWidgetSettingsEntity(state),
        monthlyChargebackCountErrorMessage: getMonthlyChargebackCountErrorMessage(state),
        mtdChargebackCount: getMonthlyChargebackCountMtdCount(state),
        previousMonthChargebackCount: getMonthlyChargebackCountPreviousMonthCount(state),
        transactionSummaryErrorMessage: getTransactionSummaryErrorMessage(state),
        transactionSummary: getTransactionSummary(state),
        user: getSelf(state)
    };
}

function mapDispatchToProps(dispatch) {
    return {
        onGetMonthlyChargebackCount: (merchantIds) => dispatch(getKpiMonthlyChargebackCount(merchantIds)),
        onGetTransactionSummary: (merchantIds) => dispatch(getKpiTransactionSummary(merchantIds))
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(Dashboard);
